<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0 font-weight-500">AKPK</h3>

    <b-row>
      <b-col cols="12">
        <div v-if="_gAuth.isAppSas()">
          <!-- ✅ Display Table if Data Exists -->
          <div v-if="tableData.length > 0" class="rounded-bottom">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                prop="akpk_approved_date"
                label="Date"
                min-width="150"
                width="auto"
              >
                <template slot-scope="scope">
                  <p class="top-line">{{ scope.row.akpk_approved_date }}</p>
                </template>
              </el-table-column>

              <el-table-column
                prop="akpk_loan_statue"
                label="Facility"
                min-width="150"
                width="auto"
              >
                <template slot-scope="scope">
                  <p class="top-line">{{ scope.row.akpk_loan_statue }}</p>
                </template>
              </el-table-column>

              <el-table-column
                prop="akpk_current_outstanding"
                label="Outstanding Balance (RM)"
                min-width="250"
                width="auto"
              >
                <template slot-scope="scope">
                  <p class="top-line">
                    {{ scope.row.akpk_current_outstanding | moneyFormatter }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- ✅ Empty State -->
          <div v-else class="bg-light p-3 text-center rounded-bottom">
            <p class="text-xs">No AKPK recorded</p>
          </div>
        </div>
        <div v-else>
          <div
            v-if="tableData.length > 0"
            class="loan-information rounded-bottom"
          >
            <b-table-simple responsive bordered>
              <b-thead>
                <b-tr>
                  <b-th rowspan="2">No.</b-th>
                  <b-th rowspan="2">Date/R&R</b-th>
                  <b-th rowspan="2">STS</b-th>
                  <b-th rowspan="2">Capacity</b-th>
                  <b-th rowspan="2"
                    >Lender<br />
                    Type</b-th
                  >
                  <b-th rowspan="2">Facility</b-th>
                  <b-th rowspan="2"
                    >Total O/S<br />
                    Balance (RM)</b-th
                  >
                  <b-th rowspan="2"
                    >Date Balance<br />
                    Updated</b-th
                  >
                  <b-th rowspan="2"
                    >Limit/Instl.<br />
                    Amt. (RM)</b-th
                  >
                  <b-th rowspan="2"
                    >Prin. Rpmt.<br />
                    Term</b-th
                  >
                  <b-th rowspan="2"
                    >Col<br />
                    Type</b-th
                  >
                  <b-th colspan="12" class="pb-0">
                    <div class="d-flex justify-content-between">
                      Conduct of Acc. for Last 12 Months
                      <small v-if="headerMonths && headerMonths.length > 0">
                        (From
                        {{
                          headerMonths[0].month_position_date +
                          " untill " +
                          headerMonths[11].month_position_date
                        }})
                      </small>
                    </div>
                  </b-th>
                  <b-th rowspan="2"
                    >Lgl<br />
                    Sts</b-th
                  >
                  <b-th rowspan="2"
                    >Date Sta.<br />
                    Updated</b-th
                  >
                </b-tr>
                <b-tr>
                  <b-th
                    v-for="(month, index) in headerMonths"
                    :key="month.month_id || index"
                    class="pt-0 pb-1"
                    >{{
                      monthAbbreviation(month.month_month) +
                      (index === 0 || index === 11
                        ? " `" +
                          (month.month_year
                            ? month.month_year.toString().slice(-2)
                            : "")
                        : "")
                    }}</b-th
                  >
                </b-tr>
              </b-thead>
              <b-tbody
                v-for="(item, index) in tableData"
                :key="item.commitment_id"
                class="text-center"
              >
                <b-tr>
                  <b-td>{{ index + 1 }}</b-td>
                  <b-td>{{ item.commitment_approved_date }}</b-td>
                  <b-td>
                    <span
                      v-if="item.commitment_status === 'K'"
                      class="sts-k-badge"
                    >
                      {{ item.commitment_status }}
                    </span>
                    <span v-else>
                      {{ item.commitment_status }}
                    </span>
                  </b-td>
                  <b-td>{{ item.commitment_capacity }}</b-td>
                  <b-td>{{ item.commitment_lender_type }}</b-td>
                  <b-td>{{ item.commitment_loan_statue }}</b-td>
                  <b-td>{{
                    item.commitment_current_outstanding === "0.00"
                      ? ""
                      : parseFloat(
                          item.commitment_current_outstanding
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                  }}</b-td>
                  <b-td>{{ item.commitment_date_balance_updated }}</b-td>
                  <b-td>{{
                    item.commitment_credit_limit | moneyFormatter
                  }}</b-td>
                  <b-td>{{ item.commitment_repay_term }}</b-td>
                  <b-td>{{ item.commitment_col_type }}</b-td>
                  <b-td
                    v-for="conduct in item.commitment_monthly"
                    :key="conduct.month_id"
                    :class="{
                      'akpk-arrears':
                        conduct.month_inst_arrears !== '0' &&
                        conduct.month_inst_arrears !== '',
                    }"
                    >{{ conduct.month_inst_arrears }}</b-td
                  >
                  <b-td>{{ item.commitment_legal_status }}</b-td>
                  <b-td>{{ item.commitment_legal_date }}</b-td>
                </b-tr>
                <b-tr
                  v-for="sub_item in item.commitment_sub_items"
                  :key="sub_item.commitment_id"
                >
                  <b-td></b-td>
                  <b-td>{{
                    sub_item.commitment_approved_date ===
                    item.commitment_approved_date
                      ? ""
                      : sub_item.commitment_approved_date
                  }}</b-td>
                  <b-td>
                    <span
                      v-if="sub_item.commitment_status === 'K'"
                      class="sts-k-badge"
                    >
                      {{
                        sub_item.commitment_status === item.commitment_status
                          ? ""
                          : sub_item.commitment_status
                      }}
                    </span>
                    <span v-else>
                      {{
                        sub_item.commitment_status === item.commitment_status
                          ? ""
                          : sub_item.commitment_status
                      }}
                    </span>
                  </b-td>
                  <b-td>{{
                    sub_item.commitment_capacity === item.commitment_capacity
                      ? ""
                      : sub_item.commitment_capacity
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_lender_type ===
                    item.commitment_lender_type
                      ? ""
                      : sub_item.commitment_lender_type
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_loan_statue ===
                    item.commitment_loan_statue
                      ? ""
                      : sub_item.commitment_loan_statue
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_current_outstanding ===
                      item.commitment_current_outstanding ||
                    sub_item.commitment_current_outstanding === "0.00"
                      ? ""
                      : parseFloat(
                          sub_item.commitment_current_outstanding
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_date_balance_updated ===
                    item.commitment_date_balance_updated
                      ? ""
                      : sub_item.commitment_date_balance_updated
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_current_installment | moneyFormatter
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_repay_term ===
                    item.commitment_repay_term
                      ? ""
                      : sub_item.commitment_repay_term
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_col_type === item.commitment_col_type
                      ? ""
                      : sub_item.commitment_col_type
                  }}</b-td>
                  <b-td
                    v-for="conduct in sub_item.commitment_monthly"
                    :key="conduct.month_id"
                    :class="{
                      'akpk-arrears':
                        conduct.month_inst_arrears !== '0' &&
                        conduct.month_inst_arrears !== '',
                    }"
                    >{{ conduct.month_inst_arrears }}</b-td
                  >
                  <b-td>{{
                    sub_item.commitment_legal_status ===
                    item.commitment_legal_status
                      ? ""
                      : sub_item.commitment_legal_status
                  }}</b-td>
                  <b-td>{{
                    sub_item.commitment_legal_date ===
                    item.commitment_legal_date
                      ? ""
                      : sub_item.commitment_legal_date
                  }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>

          <!-- Empty State -->
          <div v-else class="loan-information rounded-bottom">
            <b-table-simple responsive bordered>
              <b-thead>
                <b-tr>
                  <b-th rowspan="2">No.</b-th>
                  <b-th rowspan="2">Date/R&R</b-th>
                  <b-th rowspan="2">STS</b-th>
                  <b-th rowspan="2">Capacity</b-th>
                  <b-th rowspan="2"
                    >Lender<br />
                    Type</b-th
                  >
                  <b-th rowspan="2">Facility</b-th>
                  <b-th rowspan="2"
                    >Total O/S<br />
                    Balance (RM)</b-th
                  >
                  <b-th rowspan="2"
                    >Date Balance<br />
                    Updated</b-th
                  >
                  <b-th rowspan="2"
                    >Limit/Instl.<br />
                    Amt. (RM)</b-th
                  >
                  <b-th rowspan="2"
                    >Prin. Rpmt.<br />
                    Term</b-th
                  >
                  <b-th rowspan="2"
                    >Col<br />
                    Type</b-th
                  >
                  <b-th colspan="12" class="pb-0">
                    <div class="d-flex justify-content-between">
                      Conduct of Acc. for Last 12 Months
                      <small>(From - untill -)</small>
                    </div>
                  </b-th>
                  <b-th rowspan="2"
                    >Lgl<br />
                    Sts</b-th
                  >
                  <b-th rowspan="2"
                    >Date Sta.<br />
                    Updated</b-th
                  >
                </b-tr>
                <b-tr>
                  <b-th
                    v-for="(month, index) in headerMonths"
                    :key="month.month_id || index"
                    class="pt-0 pb-1"
                    >{{
                      monthAbbreviation(month.month_month) +
                      (index === 0 || index === 11
                        ? " `" +
                          (month.month_year
                            ? month.month_year.toString().slice(-2)
                            : "")
                        : "")
                    }}</b-th
                  >
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                  <b-td
                    v-for="(month, index) in headerMonths"
                    :key="month.month_id || index"
                    >-</b-td
                  >
                  <b-td>-</b-td>
                  <b-td>-</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-col>
    </b-row>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "AkpkCardModal",
  props: {
    akpkCard: {
      type: Array,
      default: () => [],
    },
    akpkSubItems: {
      type: Array,
      default: () => [],
    },
    show_akpk_full_view: Boolean,
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      tableData: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.show_akpk_full_view;
      },
      set(value) {
        this.$emit("update:show_akpk_full_view", value);
      },
    },
    headerMonths() {
      if (
        this.tableData &&
        this.tableData.length > 0 &&
        this.tableData[0].commitment_monthly &&
        this.tableData[0].commitment_monthly.length === 12
      ) {
        return this.tableData[0].commitment_monthly;
      }
      const now = new Date();
      const year = now.getFullYear();
      return Array.from({ length: 12 }, (v, i) => ({
        month_month: i + 1,
        month_year: year,
        month_position_date: "-",
      }));
    },
    monthAbbreviation() {
      return function (monthNumber) {
        switch (monthNumber) {
          case 1:
            return "J";
          case 2:
            return "F";
          case 3:
            return "M";
          case 4:
            return "A";
          case 5:
            return "M";
          case 6:
            return "J";
          case 7:
            return "J";
          case 8:
            return "A";
          case 9:
            return "S";
          case 10:
            return "O";
          case 11:
            return "N";
          case 12:
            return "D";
          default:
            return "";
        }
      };
    },
  },
  watch: {
    akpkSubItems: {
      immediate: true,
      handler() {
        this.resolveTableData();
      },
    },
    akpkCard: {
      immediate: true,
      handler() {
        this.resolveTableData();
      },
    },
  },
  methods: {
    resolveTableData() {
      if (_gAuth.isAppSas()) {
        this.tableData =
          this.akpkCard && this.akpkCard.length > 0 ? this.akpkCard : [];
      } else {
        this.tableData =
          this.akpkSubItems && this.akpkSubItems.length > 0
            ? this.akpkSubItems
            : [];
      }
    },
  },
};
</script>
<style>
.akpk-arrears {
  background-color: #ffe7e7 !important;
}

.sts-k-badge {
  background-color: #28a745;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: bold;
  display: inline-block;
  min-width: 20px;
  text-align: center;
}
</style>